// @ts-nocheck
import HlsAdapter from 'playable/dist/src/adapters/hls';
import HlsJs from 'hls.js/dist/hls.light.js';
export class VODHlsAdapter extends HlsAdapter {
  attach(videoElement) {
    if (!this.mediaStream) {
      return;
    }
    const config = {
      ...HlsAdapter.DEFAULT_HLS_CONFIG
    };
    this.videoElement = videoElement;
    if (this.videoElement.preload === 'none') {
      config.autoStartLoad = false;
      this.videoElement.addEventListener('play', this._attachOnPlay);
    }
    this.hls = new HlsJs(config);
    this.hls.on(HlsJs.Events.ERROR, this._broadcastError);
    this.hls.on(HlsJs.Events.LEVEL_UPDATED, this._onLevelUpdated);
    this.hls.on(HlsJs.Events.BUFFER_EOS, this._onEndOfStream);
    this.hls.loadSource(this.mediaStream.url);
    this.hls.attachMedia(this.videoElement);
    this._isAttached = true;
  }
}
//# sourceMappingURL=hls.js.map